import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";

import { BehaviorSubject } from "rxjs";
import { Hint, HINTS } from "./hints.constant";
import { StateService } from "../core/state/state.service";

@Injectable()
export class HintsService {
  public viewedHints = new BehaviorSubject<string[]>([]);
  private currentToast: any;
  private viewed: Array<string> = [];

  constructor(
    private toastCtrl: ToastController,
    private stateService: StateService,
  ) {
    this._init();
  }

  /**
   * Shows a toast with a particular set of hint data
   */
  public async showHint(hintId: string) {
    this.hideHint();

    // Create the toast with updated options
    this.currentToast = await this.toastCtrl.create({
      message: this._getHintData(hintId).text || "",
      position: "bottom",
      buttons: [
        {
          text: "OK",
          role: "cancel", // This will allow it to act as a close button
        },
      ],
      // duration: 5000, // Optionally set a duration if you want it to auto-dismiss
    });

    await this.currentToast.present();

    // Handle toast dismissal
    this.currentToast.onDidDismiss().then(() => {
      this.setViewed(hintId);
    });

    return this.currentToast;
  }

  /**
   * Hides the currently active toast.
   */
  public hideHint(): void {
    if (this.currentToast) {
      this.currentToast.dismiss();
    }
  }

  /**
   * Marks the hint as viewed.
   */
  public setViewed(hintId: string) {
    this.viewed.push(hintId);
    this.viewedHints.next(this.viewed);
  }

  public resetViewed() {
    this.viewed = [];
    this.viewedHints.next(this.viewed);
  }

  /**
   * Checks to see if the hint id is viewed
   */
  public isViewed(hintId: string) {
    return this.viewed.indexOf(hintId) > -1;
  }

  /**
   * Checks if the conditions in the hint data are met, and
   * if so returnse true.
   */
  public isVisible(hintId: string) {
    let hint = this._getHintData(hintId);

    /* if ((hint.after ?? []).some(id => !this.isViewed(id))) {
      return false;
    }

    if ((hint.hide ?? []).some(id => this.isViewed(id))) {
      return false;
    }*/

    return true;
  }

  public getHintImage(hintid: string): string {
    return this._getHintData(hintid).image || "";
  }

  public getHintViewedOrientation(hintid: string): string {
    return this._getHintData(hintid).viewedOnOrientation || "";
  }

  public getHintVisibleOrientation(hintid: string): string {
    return this._getHintData(hintid).visibleOnOrientation || "";
  }

  public getHintText(hintid: string): string {
    return this._getHintData(hintid).text || "";
  }

  public getHintTitle(hintid: string): string {
    return this._getHintData(hintid).title || "";
  }

  public getHintViewedWidth(hintid: string): string {
    return this._getHintData(hintid).viewedPastWidth || "";
  }

  public getHintViewedPlatform(hintid: string): string {
    return this._getHintData(hintid).viewedOnPlatform || "";
  }

  /**
   * Retreive the viewed hints from the state service,
   * and add a subscriber to update the state when the
   * value changes.
   */
  private _init(): void {
    /* this.stateService.getState("hintsViewed").then((viewed: any) => {
      this.viewed = viewed || [];
      this.viewedHints.next(this.viewed);
      this.viewedHints.subscribe((hintIds: any) => {
        this.stateService.setState("hintsViewed", hintIds);
      });
    }); */
  }

  /**
   * Gets hint text from constant if present
   */
  private _getHintData(hintId: string): Hint {
    return HINTS.hasOwnProperty(hintId) ? HINTS[hintId] : { text: "" };
  }
}
